import React from 'react';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { PageLayout } from '@/components/layouts/PageLayout';
import LoginPage from '@/pages/LoginPage';
import { useSelector } from 'react-redux';
import { CircularProgress } from '@mui/material';

export const AuthenticatedPageLayout = ({ children }) => {
	const firebaseReady = useSelector((state) => state.firebase.firebaseReady);

	return (
		<PageLayout>
			<AuthenticatedTemplate>
				{firebaseReady ? (
					children
				) : (
					<div
						id='authenticated-page-layout-loader'
						style={{
							display: 'flex',
							justifyContent: 'center',
							paddingTop: '4em',
						}}
					>
						<CircularProgress />
					</div>
				)}
			</AuthenticatedTemplate>

			<UnauthenticatedTemplate>
				<LoginPage />
			</UnauthenticatedTemplate>
		</PageLayout>
	);
};
